/* eslint-disable */
import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import {VERSION} from "@/common/config";
import Vuetify from '../plugins/vuetify'

import {
  LOGIN,
  SET_ERRORS,
  LOGOUT,
  CHECK_AUTH,
  SWITCH_ORGANIZATION,
  BRANDING
} from "./actions.type";
import {
  SET_AUTH,
  PURGE_AUTH,
  SET_SWITCH_ORGANIZATION_ID,
  SET_ERROR,
  SKIP_CHANGE_PASSWORD,
  SET_BRANDING,
  REFRESH,
  SET_AVATAR,
  SET_TABLE_DATA
} from "./mutations.type";

const noData = [null, '', undefined, 'null']

const getSetVersion = function() {
  let local_version = JwtService.getVersion();

  if (local_version !== VERSION) {
    JwtService.saveVersion(VERSION);
    window.location.reload(true);
  }
  return VERSION
}

const state = {
  errors: null,
  user: JwtService.getUser(),
  version: null,
  isAuthenticated: !!JwtService.getToken(),
  logo: null,
  organization_name: null,
  branding_color: null,
  show_logo: null,
  show_name: null,
  active_onboarding: true,
  switch_organization_id: null,
  first_login: JwtService.getFirstLogin(),
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  clientId(state) {
    if (state.user !== null) {
      return state.user.client_id
    } else {
      return null
    }
  },
  organizationSlug(state) {
    if (!noData.includes(state.user) && !noData.includes(state.user.organization_slug)) {
      return state.user.organization_slug
    }
    return null
  },
  firstLogin() {
    if (state.user !== null) {
      return [1, '1', true, 'true'].includes(state.first_login)
    } else {
      return false
    }
  },
  stripeCompleted() {
    if (state.user !== null && state.user.organization_status) {
      if (state.user.organization_status === 'active' && state.user.charges_enabled === 1) {
        return true
      } else if (state.user.organization_status === 'in_progress') {
        return false
      }
    } else {
      return false
    }
  },
  paymentProcessor() {
    if(
      state.user !== null &&
      state.user.card_connect_site !== undefined &&
      state.user.card_connect_site !== null
    ) {
      return 'card_connect'
    } else {
      return 'stripe'
    }
  },
  getContrast: (state) => (hexcolor) => {
    let hc = hexcolor

    if (hc.slice(0, 1) === '#') {
      hc = hc.slice(1);
    }

    if (hc.length === 3) {
      hc = hc.split('').map(function (hex) {
        return hex + hex;
        }).join('');
    }

    var r = parseInt(hc.substr(0,2),16);
    var g = parseInt(hc.substr(2,2),16);
    var b = parseInt(hc.substr(4,2),16);

    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000

    return (yiq >= 128) ? 'black' : 'white';
  },
  getContrast: (state) => (hexcolor) => {
    let hc = hexcolor

    if (hc.slice(0, 1) === '#') {
      hc = hc.slice(1);
    }

    if (hc.length === 3) {
      hc = hc.split('').map(function (hex) {
        return hex + hex;
        }).join('');
    }

    var r = parseInt(hc.substr(0,2),16);
    var g = parseInt(hc.substr(2,2),16);
    var b = parseInt(hc.substr(4,2),16);

    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000

    return (yiq >= 128) ? 'black' : 'white';
  },
  getTwoColorContrast: () => (color1 = '#ffffff', color2 = '#ffffff', returnRatio = false) => {
    const formatColor = hexcolor => {
      let hc = hexcolor

      if (hc.slice(0, 1) === '#') {
        hc = hc.slice(1);
      }
  
      if (hc.length === 3) {
        hc = hc.split('').map(function (hex) {
          return hex + hex;
          }).join('');
      }
  
      var r = parseInt(hc.substr(0,2),16);
      var g = parseInt(hc.substr(2,2),16);
      var b = parseInt(hc.substr(4,2),16);

      return [r, g, b]
    }

    let c1 = formatColor(color1)
    let c2 = formatColor(color2)

    const RED = 0.2126;
    const GREEN = 0.7152;
    const BLUE = 0.0722;

    const GAMMA = 2.4;

    const luminance = (r, g, b) => {
      var a = [r, g, b].map((v) => {
        v /= 255;
        return v <= 0.03928
          ? v / 12.92
          : Math.pow((v + 0.055) / 1.055, GAMMA);
      });
      return a[0] * RED + a[1] * GREEN + a[2] * BLUE;
    }

    const contrast = (rgb1, rgb2) => {
      var lum1 = luminance(...rgb1);
      var lum2 = luminance(...rgb2);
      var brightest = Math.max(lum1, lum2);
      var darkest = Math.min(lum1, lum2);
      return (brightest + 0.05) / (darkest + 0.05);
    }
    if (returnRatio) {
      return contrast(c1, c2)
    }
    return contrast(c1, c2) >= 3
  },
  shadeColor: () => (color, percent) => {
    const formatColor = hexcolor => {
      let hc = hexcolor

      if (hc.slice(0, 1) === '#') {
        hc = hc.slice(1);
      }
  
      if (hc.length === 3) {
        hc = hc.split('').map(function (hex) {
          return hex + hex;
          }).join('');
      }
  
      var r = parseInt(hc.substr(0,2),16);
      var g = parseInt(hc.substr(2,2),16);
      var b = parseInt(hc.substr(4,2),16);

      return [r, g, b]
    }
    let R = formatColor(color)[0];
    let G = formatColor(color)[1];
    let B = formatColor(color)[2];

    R = parseInt(R * (100 + percent) / 100);
    G = parseInt(G * (100 + percent) / 100);
    B = parseInt(B * (100 + percent) / 100);

    R = (R<255)?R:255;  
    G = (G<255)?G:255;  
    B = (B<255)?B:255;  

    R = Math.round(R)
    G = Math.round(G)
    B = Math.round(B)

    var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
    var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
    var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

    return "#"+RR+GG+BB;
  },
  correctColor: (state, getters) => (color) => {
    let out = color
    while (!getters.getTwoColorContrast(out)) {
      out = getters.shadeColor(out, -1)
    }
    return out
  },
  brandingColor(state) {
    return state.branding_color
  },
  showName(state) {
    return state.show_name
  },
  showLogo(state) {
    return state.show_logo
  },
  logo(state) {
    return state.logo
  },
  website(state) {
    return state.website
  },
  organizationName(state) {
    return state.organization_name
  },
  activeOnboarding(state) {
    return state.active_onboarding
  },
  clientType(state) {
    return state.user !== null &&
      state.user.commercial_client_id !== undefined &&
      state.user.commercial_client_id !== null ?
        'commercial' : 
        'residential'
  },
  commercialClientId(state) {
    if(
      !noData.includes(state.user) &&
      !noData.includes(state.user.commercial_client_id)
    ) {
      return state.user.commercial_client_id
    } else {
      return null
    }
  },
  organizationId(state) {
    if(
      !noData.includes(state.user) &&
      !noData.includes(state.user.organization_id)
    ) {
      return state.user.organization_id
    } else {
      return null
    }
  },
  tableData: state => data => {
    return state[data]
  },
  tipsEnabled (state) {
    return !noData.includes(state.user) &&
      !noData.includes(state.user.organization_settings) &&
      state.user.organization_settings.some(i => i.key === 'rating_tipping' && i.value === 'enabled_all')
  },
  organizationSettings(state) {
    if(
      !noData.includes(state.user) &&
      !noData.includes(state.user.organization_settings) &&
      Array.isArray(state.user.organization_settings) &&
      state.user.organization_settings.every(i => !noData.includes(i.key))
    ) {
      let organization_settings = {}
      state.user.organization_settings.forEach(i => {
        organization_settings[i.key] = i.value;
      })
      return organization_settings
    } else {
      return null
    }
  },
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("auth/client_login", credentials)
        .then(({ data }) => {
            if(data.token){
              context.commit(SET_AUTH, data);
              context.dispatch('setOrganizationBranding')
              if (data.user) {
                context.commit('setFirstLogin', data.user.first_login)
              }
              resolve(data);
            }else{
              context.commit(SET_ERROR, data);
              reject(data);
            }
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  },
  [LOGOUT](context, slug) {
    return new Promise((resolve, reject) => {
      context.commit(PURGE_AUTH);
      context.dispatch('setOrganizationBranding')
      if (!noData.includes(slug)) {
        resolve(slug)
      } else {
        resolve(null)
      }
    })
  },
  [SET_ERRORS](context, errors) {
    context.commit(SET_ERROR, errors);
  },
  [CHECK_AUTH](context, token) {
    return new Promise((resolve, reject) => {
      const currentToken = token || JwtService.getToken();
      if (token) {
        ApiService.setHeader(token);
      } else {
        ApiService.setHeader();
      }
      const url = context.getters.clientType === 'commercial' ?
        '/commercial_client/auth/commercial_user' :
        '/client/auth/client_user'
      let body = {}
      if (!noData.includes(context.state.switch_organization_id)) {
        body.organization_id = context.state.switch_organization_id.organization_id
        body.client_id = context.state.switch_organization_id.client_id
        // body.commercial_client_id = context.state.switch_organization_id.commercial_client_id
      }
      ApiService.get(url, body)
        .then(({ data }) => {
          context.commit(SET_AUTH, { token: currentToken, user: data.user });
          context.commit(SET_SWITCH_ORGANIZATION_ID, null);
          context.dispatch('setOrganizationBranding')
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
          context.commit(PURGE_AUTH);
          context.commit(SET_SWITCH_ORGANIZATION_ID, null);
          context.dispatch('setOrganizationBranding')
          reject(response);
        });
    });
  },
  [SWITCH_ORGANIZATION](context, id) {
    return new Promise((resolve, reject) => {
      context.commit(SET_SWITCH_ORGANIZATION_ID, id)
      context.dispatch(CHECK_AUTH)
        .then(response => { resolve(response) })
        .catch(error => { reject(error) })
    })
  },
  [BRANDING](context, payload) {
    return new Promise((resolve, reject) => {
      if (!noData.includes(payload) && !noData.includes(payload.organization)) {
        ApiService.get("client_on_boarding/organization_data", payload)
          .then(({ data }) => {
            context.commit(SET_BRANDING, data);
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit(SET_ERROR, response.data.errors);
            reject(response);
          });
      } else {
        reject()
      }
    });
  },
  setOrganizationBranding (context) {
    let data = {
      primary: '#00838F',
      header: '#212121'
    }
    if (
      !noData.includes(context) &&
      !noData.includes(context.getters) &&
      !noData.includes(context.getters.organizationSettings)
    ) {
      if (!noData.includes(context.getters.organizationSettings.primary_color)) {
        data.primary = context.getters.correctColor(context.getters.organizationSettings.primary_color)
      }
      if (!noData.includes(context.getters.organizationSettings.header_color)) {
        data.header = context.getters.organizationSettings.header_color
      }
    }
    context.commit('setOrganizationBranding', data)
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.errors = {};
    JwtService.saveToken(user.token);
    JwtService.saveOrganizationId(user.user.organization_id);
    JwtService.saveUserId(user.user.user_id);
    JwtService.saveUser(user.user);
    state.isAuthenticated = !!JwtService.getToken()
    state.user = JwtService.getUser()
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
    JwtService.destroyOrganizationId();
    JwtService.destroyUserId();
    JwtService.destroyUser();
    JwtService.destroyFirstLogin();
  },
  refreshAuth (state) {
    state.isAuthenticated = !!JwtService.getToken()
  },
  [SET_SWITCH_ORGANIZATION_ID](state, id) {
    state.switch_organization_id = id
  },
  setFirstLogin (state, data) {
    state.first_login = data
    JwtService.saveFirstLogin(data);
  },
  [SKIP_CHANGE_PASSWORD](state) {
    let user = state.user
    user.first_login = 0
    JwtService.saveUser(user);
    state.first_login = 0
    JwtService.saveFirstLogin(0);
  },
  [SET_BRANDING](state, data) {
    let no_data = (input) => {
      return [null, '', undefined, 'null'].includes(input)
    }
    if (!no_data(data.organization.logo)) state.logo = data.organization.logo
    if (!no_data(data.organization.organization_name)) state.organization_name = data.organization.organization_name
    if (!no_data(data.organization.branding_color)) state.branding_color = data.organization.branding_color
    if (!no_data(data.organization.website)) state.website = data.organization.website
    if (!no_data(data.organization.show_logo_onboarding)) state.show_logo = Boolean(Number(data.organization.show_logo_onboarding))
    if (!no_data(data.organization.show_name_onboarding)) state.show_name = Boolean(Number(data.organization.show_name_onboarding))
    if (!no_data(data.organization.organization_can_have_onboarding)) state.active_onboarding = data.organization.organization_can_have_onboarding
  },
  [REFRESH](state) {
    state.version = getSetVersion()
  },
  [SET_AVATAR] (state, data) {
    if(state.user.avatar !== data) {
      state.user.avatar = data
      JwtService.saveUser(state.user)
    }
  },
  [SET_TABLE_DATA](state, data) {
    state[data.key] = data.value
  },
  setOrganizationBranding (state, data) {
    Vuetify.framework.theme.themes.light.accent = data.primary
    Vuetify.framework.theme.themes.light.header = data.header
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
